import React from "react";
import LandingNavbar from "./LandingNavbar";
import LandingFooter from "./LandingFooter";

const LandingLayout = ({ children, noPt = false }) => {
    return (
        <div className="min-h-screen bg-white font-sans text-gray-800 flex flex-col">
            <LandingNavbar />
            <div className={`flex-grow ${noPt ? '' : 'pt-20'}`}>
                {children}
            </div>
            <LandingFooter />
        </div>
    );
};

export default LandingLayout;
